import React, { useState } from "react"; 
import Navbar from "./Sub/navbar";
import Footer from "./Sub/footer";
import ContactForum from "./Sub/Contact-Forum"
import WhatsAppButton from "./Sub/wa";
import { useNavigate } from "react-router-dom";


const App = () => {
    const navigate = useNavigate();
    const home = () => {
      navigate("/contacto");
    }
  return (
    <>
      <Navbar 
        onScrollToNosotros={home}
        onScrollToProyectos={home}
        onScrollToProceso={home}
        onScrollToPlanes={home}
      />
      <ContactForum/>
      <Footer />
      <WhatsAppButton />
    </>
  );
};

export default App;


